var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Baseline',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"10","sm":"6","md":"4","lg":"3"}},[_c('Login')],1)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }